import { render, staticRenderFns } from "./tableTag.vue?vue&type=template&id=64e066e9&scoped=true"
import script from "./tableTag.vue?vue&type=script&lang=js"
export * from "./tableTag.vue?vue&type=script&lang=js"
import style0 from "./tableTag.vue?vue&type=style&index=0&id=64e066e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e066e9",
  null
  
)

export default component.exports